export function normalizeConnectEmail(email: string): string {
    return email.trim().toLowerCase();
}

/** Returns true when both emails are present and differ (case-insensitive). */
export function hasConnectEmailMismatch(
    appEmail: string | null | undefined,
    ccpEmail: string | null | undefined,
): boolean {
    const app = appEmail?.trim();
    const ccp = ccpEmail?.trim();
    if (!app || !ccp) return false;
    return normalizeConnectEmail(app) !== normalizeConnectEmail(ccp);
}
